import AppShell from "./AppShell";
import { getApp } from "@/lib/apps";

const Spiritsynq = () => <AppShell app={getApp("spiritsynq")} />;

export default Spiritsynq;
